// components/Audience/Leaderboard.tsx
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { LeaderboardEntry } from '../../types/quiz.types';
import { subscribeToLeaderboard } from '../../services/live-session';
import { rankChip } from '../../constants/answer-tiles';

export const Leaderboard = () => {
  const { sessionCode } = useParams<{ sessionCode: string }>();
  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);

  useEffect(() => {
    if (!sessionCode) return;
    // Already published top-N and pre-sorted by the presenter; render as-is.
    return subscribeToLeaderboard(sessionCode, setLeaderboard);
  }, [sessionCode]);

  return (
    <div className="stage px-4 py-12">
      <div className="card max-w-lg mx-auto p-8 animate-pop">
        <h2 className="text-3xl font-extrabold font-display tracking-tight text-center mb-6">Leaderboard</h2>
        {leaderboard.length === 0 ? (
          <p className="p-4 text-center text-slate-400">No scores yet.</p>
        ) : (
          <ol className="space-y-2">
            {leaderboard.map((entry, index) => (
              <li
                key={entry.uid}
                className={`flex items-center gap-3 p-4 rounded-xl ${index < 3 ? 'bg-accent/15' : 'bg-slate-50'}`}
              >
                <span className={rankChip(index)}>{index + 1}</span>
                <span className="flex-1 font-medium truncate">{entry.name}</span>
                <span className="font-display font-bold text-ink">{entry.score} pts</span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
};
